var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPagination)?_c('ecBlogPage',{attrs:{"page":_vm.pageNum}}):(_vm.page)?_c('v-container',[_c('nuxt-content',{attrs:{"document":_vm.page}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }